import Glider from 'glider-js';

import { MQ } from '../tools/MQ';

export const init = () => {
	const heroCards = Array.from(document.querySelectorAll('.js-hero-cards'));

	if (MQ('lgDown')) {
		heroCards.forEach((item, index) => {
			new Glider(item, {
				slidesToShow: 1,
				slidesToScroll: 1,
				dots: '.js-hero-dots',
				draggable: true,
			});
		});
	}
};
